import { EventContextProvider } from "@codat/analytics";
import { Modal, useToast } from "@codat/orchard-ui";
import { PushOperationError } from "api/models/PushOperation";

import CodeBlock from "components/CodeBlock";

export interface PushOperationErrorModalProps {
  onClose: () => void;
  errors: (PushOperationError | string)[] | undefined;
  id: string;
  companyId: string;
  dataType: string;
  requestedAt: string;
}

const ErrorModal = ({
  onClose,
  id,
  errors,
  companyId,
  dataType,
  requestedAt,
}: PushOperationErrorModalProps) => {
  const { addToast } = useToast();

  return (
    <EventContextProvider name="Validation error modal">
      <Modal onClose={onClose} size="medium">
        <>
          <Modal.Header onClose={onClose} title="Validation error response" />
          <Modal.Body variant="light">
            {errors?.map((error, index) => (
              <Modal.Section key={index} variant="fill">
                <CodeBlock
                  codeBlockName="Push Operation error modal"
                  code={error}
                  copyOptions={{
                    onSuccess: () => {
                      addToast({
                        message: "Copied validation response to clipboard",
                        variant: "success",
                      });
                    },
                    onFailure: (err) => {
                      addToast({
                        variant: "error",
                        message:
                          "Error copying validation response to clipboard",
                      });
                      //eslint-disable-next-line no-console
                      console.error(err);
                    },
                  }}
                  downloadOptions={{
                    filename: `${companyId} - ${id}.${dataType} - ${requestedAt}.json`,
                    onFailure: (err) => {
                      addToast({
                        variant: "error",
                        message: "Error downloading error response",
                      });
                      //eslint-disable-next-line no-console
                      console.error(err);
                    },
                  }}
                />
              </Modal.Section>
            ))}
          </Modal.Body>
        </>
      </Modal>
    </EventContextProvider>
  );
};

export default ErrorModal;
